"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMIL AuthService
 * The EMIL AuthService API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthserviceApi = exports.AuthserviceApiFactory = exports.AuthserviceApiFp = exports.AuthserviceApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * AuthserviceApi - axios parameter creator
 * @export
 */
var AuthserviceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Register a new organization with appropriate hierarchy and create a user for that organization.
         * @summary Register Organization and User using invitation token
         * @param {CreateOrgAndUserRequestDto} createOrgAndUserRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgAndUser: function (createOrgAndUserRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createOrgAndUserRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('createOrgAndUser', 'createOrgAndUserRequestDto', createOrgAndUserRequestDto);
                    localVarPath = "/authservice/v1/create-org-and-user";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createOrgAndUserRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Register a tenant user using the invite token sent to the tenant user\'s email address.
         * @summary Register tenant user after invite
         * @param {CreateUserRequestDto} createUserRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: function (createUserRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createUserRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('createUser', 'createUserRequestDto', createUserRequestDto);
                    localVarPath = "/authservice/v1/create-user";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createUserRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Send a tenant user a reset-password token via email.
         * @summary Forgot password by tenant
         * @param {ForgotPasswordRequestDto} forgotPasswordRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: function (forgotPasswordRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'forgotPasswordRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('forgotPassword', 'forgotPasswordRequestDto', forgotPasswordRequestDto);
                    localVarPath = "/authservice/v1/forgot-password";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(forgotPasswordRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get SAML login link configured for the tenant in cognito as well as tenant settings
         * @summary Get SAML login link for tenant
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamlLoginLink: function (tenantSlug, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'tenantSlug' is not null or undefined
                    (0, common_1.assertParamExists)('getSamlLoginLink', 'tenantSlug', tenantSlug);
                    localVarPath = "/authservice/v1/saml-login-link";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (tenantSlug !== undefined) {
                        localVarQueryParameter['tenantSlug'] = tenantSlug;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get new access token, refresh token after successful login.
         * @summary Login by tenant
         * @param {LoginRequestDto} loginRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: function (loginRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'loginRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('login', 'loginRequestDto', loginRequestDto);
                    localVarPath = "/authservice/v1/login";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loginRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get new access token, refresh token after successful login. This api also creates a tenant user if user does not exist
         * @summary Login by SAML idp provider such as ADFS
         * @param {LoginBySamlRequestDto} loginBySamlRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBySaml: function (loginBySamlRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'loginBySamlRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('loginBySaml', 'loginBySamlRequestDto', loginBySamlRequestDto);
                    localVarPath = "/authservice/v1/login/saml";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loginBySamlRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Sign tenant user out.
         * @summary Logout tenant
         * @param {LogoutRequestDto} logoutRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: function (logoutRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'logoutRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('logout', 'logoutRequestDto', logoutRequestDto);
                    localVarPath = "/authservice/v1/logout";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(logoutRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get new access token, new refresh token.
         * @summary Refresh token by tenant
         * @param {RefreshTokenDto} refreshTokenDto
         * @param {string} [cookie] HTTP only cookie that was sent during login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: function (refreshTokenDto, cookie, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'refreshTokenDto' is not null or undefined
                    (0, common_1.assertParamExists)('refreshToken', 'refreshTokenDto', refreshTokenDto);
                    localVarPath = "/authservice/v1/refresh-token";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cookie !== undefined && cookie !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                        localVarHeaderParameter['Cookie'] = String(cookie ? cookie : baseAccessToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(refreshTokenDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Change tenant user\'s password using the token provided by the reset password endpoint.
         * @summary Change password by tenant
         * @param {ResetPasswordRequestDto} resetPasswordRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: function (resetPasswordRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'resetPasswordRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('resetPassword', 'resetPasswordRequestDto', resetPasswordRequestDto);
                    localVarPath = "/authservice/v1/reset-password";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(resetPasswordRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Verify the invite sent to the tenant user via email.
         * @summary Verify tenant user\'s invite token
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyInvite: function (token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'token' is not null or undefined
                    (0, common_1.assertParamExists)('verifyInvite', 'token', token);
                    localVarPath = "/authservice/v1/verify-invite";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (token !== undefined) {
                        localVarQueryParameter['token'] = token;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Verifies token and returns necessary data for signing up as an organization.
         * @summary Verify a organization\'s invitation token
         * @param {string} invitationToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOrgInvitation: function (invitationToken, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'invitationToken' is not null or undefined
                    (0, common_1.assertParamExists)('verifyOrgInvitation', 'invitationToken', invitationToken);
                    localVarPath = "/authservice/v1/verify-org-invitation";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (invitationToken !== undefined) {
                        localVarQueryParameter['invitationToken'] = invitationToken;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Verify the reset password token that is sent by calling the \'forgot password\' endpoint.
         * @summary Verify tenant reset password token
         * @param {string} resetToken Tenant user\&#39;s reset token. Reset token can be found in the email        sent after \&#39;forgot-password\&#39; endpoint was called.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyResetPasswordToken: function (resetToken, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'resetToken' is not null or undefined
                    (0, common_1.assertParamExists)('verifyResetPasswordToken', 'resetToken', resetToken);
                    localVarPath = "/authservice/v1/verify-reset-password";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (resetToken !== undefined) {
                        localVarQueryParameter['resetToken'] = resetToken;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AuthserviceApiAxiosParamCreator = AuthserviceApiAxiosParamCreator;
/**
 * AuthserviceApi - functional programming interface
 * @export
 */
var AuthserviceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AuthserviceApiAxiosParamCreator)(configuration);
    return {
        /**
         * Register a new organization with appropriate hierarchy and create a user for that organization.
         * @summary Register Organization and User using invitation token
         * @param {CreateOrgAndUserRequestDto} createOrgAndUserRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgAndUser: function (createOrgAndUserRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createOrgAndUser(createOrgAndUserRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Register a tenant user using the invite token sent to the tenant user\'s email address.
         * @summary Register tenant user after invite
         * @param {CreateUserRequestDto} createUserRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: function (createUserRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createUser(createUserRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Send a tenant user a reset-password token via email.
         * @summary Forgot password by tenant
         * @param {ForgotPasswordRequestDto} forgotPasswordRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: function (forgotPasswordRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.forgotPassword(forgotPasswordRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get SAML login link configured for the tenant in cognito as well as tenant settings
         * @summary Get SAML login link for tenant
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamlLoginLink: function (tenantSlug, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSamlLoginLink(tenantSlug, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get new access token, refresh token after successful login.
         * @summary Login by tenant
         * @param {LoginRequestDto} loginRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: function (loginRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.login(loginRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get new access token, refresh token after successful login. This api also creates a tenant user if user does not exist
         * @summary Login by SAML idp provider such as ADFS
         * @param {LoginBySamlRequestDto} loginBySamlRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBySaml: function (loginBySamlRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginBySaml(loginBySamlRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Sign tenant user out.
         * @summary Logout tenant
         * @param {LogoutRequestDto} logoutRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: function (logoutRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.logout(logoutRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get new access token, new refresh token.
         * @summary Refresh token by tenant
         * @param {RefreshTokenDto} refreshTokenDto
         * @param {string} [cookie] HTTP only cookie that was sent during login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: function (refreshTokenDto, cookie, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refreshToken(refreshTokenDto, cookie, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Change tenant user\'s password using the token provided by the reset password endpoint.
         * @summary Change password by tenant
         * @param {ResetPasswordRequestDto} resetPasswordRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: function (resetPasswordRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.resetPassword(resetPasswordRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Verify the invite sent to the tenant user via email.
         * @summary Verify tenant user\'s invite token
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyInvite: function (token, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.verifyInvite(token, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Verifies token and returns necessary data for signing up as an organization.
         * @summary Verify a organization\'s invitation token
         * @param {string} invitationToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOrgInvitation: function (invitationToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.verifyOrgInvitation(invitationToken, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Verify the reset password token that is sent by calling the \'forgot password\' endpoint.
         * @summary Verify tenant reset password token
         * @param {string} resetToken Tenant user\&#39;s reset token. Reset token can be found in the email        sent after \&#39;forgot-password\&#39; endpoint was called.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyResetPasswordToken: function (resetToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.verifyResetPasswordToken(resetToken, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AuthserviceApiFp = AuthserviceApiFp;
/**
 * AuthserviceApi - factory interface
 * @export
 */
var AuthserviceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AuthserviceApiFp)(configuration);
    return {
        /**
         * Register a new organization with appropriate hierarchy and create a user for that organization.
         * @summary Register Organization and User using invitation token
         * @param {CreateOrgAndUserRequestDto} createOrgAndUserRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgAndUser: function (createOrgAndUserRequestDto, options) {
            return localVarFp.createOrgAndUser(createOrgAndUserRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Register a tenant user using the invite token sent to the tenant user\'s email address.
         * @summary Register tenant user after invite
         * @param {CreateUserRequestDto} createUserRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: function (createUserRequestDto, options) {
            return localVarFp.createUser(createUserRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Send a tenant user a reset-password token via email.
         * @summary Forgot password by tenant
         * @param {ForgotPasswordRequestDto} forgotPasswordRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: function (forgotPasswordRequestDto, options) {
            return localVarFp.forgotPassword(forgotPasswordRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get SAML login link configured for the tenant in cognito as well as tenant settings
         * @summary Get SAML login link for tenant
         * @param {string} tenantSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamlLoginLink: function (tenantSlug, options) {
            return localVarFp.getSamlLoginLink(tenantSlug, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get new access token, refresh token after successful login.
         * @summary Login by tenant
         * @param {LoginRequestDto} loginRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: function (loginRequestDto, options) {
            return localVarFp.login(loginRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get new access token, refresh token after successful login. This api also creates a tenant user if user does not exist
         * @summary Login by SAML idp provider such as ADFS
         * @param {LoginBySamlRequestDto} loginBySamlRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBySaml: function (loginBySamlRequestDto, options) {
            return localVarFp.loginBySaml(loginBySamlRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Sign tenant user out.
         * @summary Logout tenant
         * @param {LogoutRequestDto} logoutRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: function (logoutRequestDto, options) {
            return localVarFp.logout(logoutRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get new access token, new refresh token.
         * @summary Refresh token by tenant
         * @param {RefreshTokenDto} refreshTokenDto
         * @param {string} [cookie] HTTP only cookie that was sent during login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: function (refreshTokenDto, cookie, options) {
            return localVarFp.refreshToken(refreshTokenDto, cookie, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Change tenant user\'s password using the token provided by the reset password endpoint.
         * @summary Change password by tenant
         * @param {ResetPasswordRequestDto} resetPasswordRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: function (resetPasswordRequestDto, options) {
            return localVarFp.resetPassword(resetPasswordRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Verify the invite sent to the tenant user via email.
         * @summary Verify tenant user\'s invite token
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyInvite: function (token, options) {
            return localVarFp.verifyInvite(token, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Verifies token and returns necessary data for signing up as an organization.
         * @summary Verify a organization\'s invitation token
         * @param {string} invitationToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOrgInvitation: function (invitationToken, options) {
            return localVarFp.verifyOrgInvitation(invitationToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Verify the reset password token that is sent by calling the \'forgot password\' endpoint.
         * @summary Verify tenant reset password token
         * @param {string} resetToken Tenant user\&#39;s reset token. Reset token can be found in the email        sent after \&#39;forgot-password\&#39; endpoint was called.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyResetPasswordToken: function (resetToken, options) {
            return localVarFp.verifyResetPasswordToken(resetToken, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AuthserviceApiFactory = AuthserviceApiFactory;
/**
 * AuthserviceApi - object-oriented interface
 * @export
 * @class AuthserviceApi
 * @extends {BaseAPI}
 */
var AuthserviceApi = /** @class */ (function (_super) {
    __extends(AuthserviceApi, _super);
    function AuthserviceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Register a new organization with appropriate hierarchy and create a user for that organization.
     * @summary Register Organization and User using invitation token
     * @param {AuthserviceApiCreateOrgAndUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthserviceApi
     */
    AuthserviceApi.prototype.createOrgAndUser = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthserviceApiFp)(this.configuration).createOrgAndUser(requestParameters.createOrgAndUserRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Register a tenant user using the invite token sent to the tenant user\'s email address.
     * @summary Register tenant user after invite
     * @param {AuthserviceApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthserviceApi
     */
    AuthserviceApi.prototype.createUser = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthserviceApiFp)(this.configuration).createUser(requestParameters.createUserRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Send a tenant user a reset-password token via email.
     * @summary Forgot password by tenant
     * @param {AuthserviceApiForgotPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthserviceApi
     */
    AuthserviceApi.prototype.forgotPassword = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthserviceApiFp)(this.configuration).forgotPassword(requestParameters.forgotPasswordRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get SAML login link configured for the tenant in cognito as well as tenant settings
     * @summary Get SAML login link for tenant
     * @param {AuthserviceApiGetSamlLoginLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthserviceApi
     */
    AuthserviceApi.prototype.getSamlLoginLink = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthserviceApiFp)(this.configuration).getSamlLoginLink(requestParameters.tenantSlug, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get new access token, refresh token after successful login.
     * @summary Login by tenant
     * @param {AuthserviceApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthserviceApi
     */
    AuthserviceApi.prototype.login = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthserviceApiFp)(this.configuration).login(requestParameters.loginRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get new access token, refresh token after successful login. This api also creates a tenant user if user does not exist
     * @summary Login by SAML idp provider such as ADFS
     * @param {AuthserviceApiLoginBySamlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthserviceApi
     */
    AuthserviceApi.prototype.loginBySaml = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthserviceApiFp)(this.configuration).loginBySaml(requestParameters.loginBySamlRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Sign tenant user out.
     * @summary Logout tenant
     * @param {AuthserviceApiLogoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthserviceApi
     */
    AuthserviceApi.prototype.logout = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthserviceApiFp)(this.configuration).logout(requestParameters.logoutRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get new access token, new refresh token.
     * @summary Refresh token by tenant
     * @param {AuthserviceApiRefreshTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthserviceApi
     */
    AuthserviceApi.prototype.refreshToken = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthserviceApiFp)(this.configuration).refreshToken(requestParameters.refreshTokenDto, requestParameters.cookie, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Change tenant user\'s password using the token provided by the reset password endpoint.
     * @summary Change password by tenant
     * @param {AuthserviceApiResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthserviceApi
     */
    AuthserviceApi.prototype.resetPassword = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthserviceApiFp)(this.configuration).resetPassword(requestParameters.resetPasswordRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Verify the invite sent to the tenant user via email.
     * @summary Verify tenant user\'s invite token
     * @param {AuthserviceApiVerifyInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthserviceApi
     */
    AuthserviceApi.prototype.verifyInvite = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthserviceApiFp)(this.configuration).verifyInvite(requestParameters.token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Verifies token and returns necessary data for signing up as an organization.
     * @summary Verify a organization\'s invitation token
     * @param {AuthserviceApiVerifyOrgInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthserviceApi
     */
    AuthserviceApi.prototype.verifyOrgInvitation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthserviceApiFp)(this.configuration).verifyOrgInvitation(requestParameters.invitationToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Verify the reset password token that is sent by calling the \'forgot password\' endpoint.
     * @summary Verify tenant reset password token
     * @param {AuthserviceApiVerifyResetPasswordTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthserviceApi
     */
    AuthserviceApi.prototype.verifyResetPasswordToken = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthserviceApiFp)(this.configuration).verifyResetPasswordToken(requestParameters.resetToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AuthserviceApi;
}(base_1.BaseAPI));
exports.AuthserviceApi = AuthserviceApi;
